module.exports = __webpack_public_path__ + "vote.0fd103eb.png";